export default __webpack_public_path__ + "static/media/svg.482173ec.svg";